import tablePhoto from "../Assets/Images/photoCamera.png";

export const InventoryRows = [
    {
      id: 1,
      photos: tablePhoto,
      name: "Snow abc",
      sku: "23888998111",
      condition: "New",
      location: "Warehouse1",
      available: 13456,
      reserved: 1300,
      onHand: 453,
    },
    {
      id: 2,
      photos: tablePhoto,
      name: "Snow xyz",
      sku: "2388899222",
      condition: "Old",
      location: "Warehouse1",
      available: 13422,
      reserved: 1322,
      onHand: 223,
    },
    {
      id: 3,
      photos: tablePhoto,
      name: "Snow rst",
      sku: "23888998333",
      condition: "Modified",
      location: "Warehouse Old",
      available: 13422,
      reserved: 1310,
      onHand: 400,
    },
    {
      id: 4,
      photos: tablePhoto,
      name: "Snow Man",
      sku: "23888998444",
      condition: "Old",
      location: "Warehouse1",
      available: 11456,
      reserved: 1200,
      onHand: 45,
    },
    {
      id: 5,
      photos: tablePhoto,
      name: "Snow Den",
      sku: "23888998555",
      condition: "Modified",
      location: "Warehouse one",
      available: 136,
      reserved: 100,
      onHand: 321,
    },
    {
      id: 6,
      photos: tablePhoto,
      name: "Snow Fall",
      sku: "23888998666",
      condition: "New",
      location: "Warehouse three",
      available: 19456,
      reserved: 100,
      onHand: 213,
    },
    {
      id: 7,
      photos: tablePhoto,
      name: "Snow Jenkins",
      sku: "2388899777",
      condition: "New",
      location: "Warehouse one",
      available: 19951,
      reserved: 1410,
      onHand: 450,
    },
  ];